/* KAST Boost: custom upsell toolkit (no app). */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FREE_ITEMS = 2;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-US');
  }
  function img(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src.indexOf('width=') > -1) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function priceHTML(price, compare) {
    if (compare && compare > price) {
      return '<span class="kb-price"><s>' + money(compare) + '</s><span class="is-sale">' + money(price) + '</span></span>';
    }
    return '<span class="kb-price"><span>' + money(price) + '</span></span>';
  }
  function shake(el) {
    if (!el) return;
    el.classList.remove('kb-shake');
    void el.offsetWidth;
    el.classList.add('kb-shake');
  }

  /* ---------- data ---------- */
  var recCache = {};
  function related(productId, limit) {
    var key = productId + ':' + (limit || 10);
    if (!recCache[key]) {
      recCache[key] = fetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=' + (limit || 10) + '&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    return recCache[key];
  }
  /* collection feed via the kast-upsell alternate template (respects sort_by) */
  var collCache = {};
  function coll(handle, sort) {
    var key = handle + ':' + sort;
    if (!collCache[key]) {
      collCache[key] = fetch(ROOT + 'collections/' + handle + '?sort_by=' + sort + '&view=kast-upsell')
        .then(function (r) { return r.ok ? r.text() : '[]'; })
        .then(function (t) { return JSON.parse(t.trim()); })
        .catch(function () { return []; });
    }
    return collCache[key];
  }
  function isBottom(type) {
    return /jean|trouser|pant|short|cargo|bottom/i.test(type || '');
  }
  function getProduct(handle) {
    return fetch(ROOT + 'products/' + handle + '.js').then(function (r) { return r.json(); });
  }

  /* Prefer a mix of different product types (jeans -> polo, trouser...) */
  function pickMix(list, baseTypes, excludeIds, n) {
    var avail = list.filter(function (p) { return p.available && excludeIds.indexOf(p.id) === -1; });
    var out = [];
    var usedTypes = baseTypes.slice();
    avail.forEach(function (p) {
      if (out.length < n && p.type && usedTypes.indexOf(p.type) === -1) { out.push(p); usedTypes.push(p.type); }
    });
    avail.forEach(function (p) {
      if (out.length < n && out.indexOf(p) === -1 && baseTypes.indexOf(p.type) === -1) out.push(p);
    });
    avail.forEach(function (p) {
      if (out.length < n && out.indexOf(p) === -1) out.push(p);
    });
    return out;
  }

  /* ---------- cart ---------- */
  function sectionsList() {
    try {
      if (typeof sectionsToRender !== 'undefined' && sectionsToRender.length) {
        return sectionsToRender.map(function (s) { return s.section; });
      }
    } catch (e) {}
    return ['cart-drawer'];
  }
  function addItems(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsList(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add to bag');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.renderContents(res.j, true);
        } else {
          window.location.href = ROOT + 'cart';
        }
        try { if (typeof updateCartCounters === 'function') updateCartCounters(); } catch (e) {}
        document.dispatchEvent(new CustomEvent('kast:cart-updated'));
        return res.j;
      });
  }

  /* ---------- variant picker (pills) ---------- */
  function shortSize(t) {
    return t.replace(/^X-Large$/i, 'XL').replace(/^XX-Large$/i, 'XXL').replace(/^Small$/i, 'S').replace(/^Medium$/i, 'M').replace(/^Large$/i, 'L');
  }
  function sizePickerHTML(p) {
    if (p.variants.length <= 1) return '';
    var pills = p.variants.map(function (v) {
      return '<button type="button" class="kb-size" data-variant="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '"' +
        (v.available ? '' : ' disabled') + ' aria-label="' + esc(v.title) + '">' + esc(shortSize(v.title)) + '</button>';
    }).join('');
    return '<div class="kb-sizes" role="group" aria-label="Choose size">' + pills + '</div>';
  }
  function bindPills(scope, onPick) {
    scope.addEventListener('click', function (e) {
      var b = e.target.closest('.kb-size');
      if (!b || b.disabled || !scope.contains(b)) return;
      var group = b.closest('.kb-sizes');
      group.querySelectorAll('.kb-size').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      if (onPick) onPick(b, group);
    });
  }

  /* =========================================================
     Cart drawer upsell
     ========================================================= */
  if (!customElements.get('kast-cart-upsell')) {
    customElements.define('kast-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        var self = this;
        var ids = (this.dataset.productIds || '').split(',').filter(Boolean).map(Number);
        var types = (this.dataset.types || '').split('|').filter(Boolean);
        if (!ids.length) { this.hidden = true; return; }
        var track = this.querySelector('[data-track]');

        /* tops in the bag -> suggest bottoms; bottoms in the bag -> suggest tops */
        var hasBottom = types.some(isBottom);
        var hasTop = !types.length || types.some(function (t) { return !isBottom(t); });
        var targets = [];
        if (hasTop) targets.push(this.dataset.bottoms);
        if (hasBottom) targets.push(this.dataset.tops);

        Promise.all(targets.map(function (h) {
          return Promise.all([coll(h, 'best-selling'), coll(h, 'created-descending')]);
        })).then(function (groups) {
          var picks = [];
          var seen = {};
          var add = function (p, badge) {
            if (!p || seen[p.id] || !p.available || ids.indexOf(p.id) > -1) return;
            seen[p.id] = true;
            p._badge = badge;
            picks.push(p);
          };
          /* mix: two best sellers, then one new arrival, across each target */
          for (var i = 0; i < 10; i++) {
            groups.forEach(function (g) {
              add(g[0][2 * i], 'Best seller');
              add(g[0][2 * i + 1], 'Best seller');
              add(g[1][i], 'New in');
            });
          }
          picks = picks.slice(0, 8);
          if (!picks.length) { self.hidden = true; return; }
          track.innerHTML = picks.map(function (p) {
            var single = p.variants.length <= 1 ? p.variants[0].id : '';
            return '<div class="kb-card" data-product="' + p.id + '" data-single="' + single + '">' +
              '<a class="kb-card__media" href="' + p.url + '"><span class="kb-card__badge' + (p._badge === 'New in' ? ' is-new' : '') + '">' + p._badge + '</span>' +
              '<img loading="lazy" alt="' + esc(p.title) + '" src="' + img(p.featured_image, 240) + '"></a>' +
              '<div class="kb-card__body">' +
                '<a class="kb-card__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
                '<div data-price-slot>' + priceHTML(p.price, p.compare_at_price) + '</div>' +
                sizePickerHTML(p) +
                '<div class="kb-card__foot"><span class="kb-card__hint" data-hint>Pick a size</span>' +
                '<button type="button" class="kb-btn kb-btn--sm" data-add><span class="kb-btn__label">Add +</span></button></div>' +
              '</div></div>';
          }).join('');
          self.hidden = false;
        });

        bindPills(this, function (b) {
          var card = b.closest('.kb-card');
          card.dataset.variant = b.dataset.variant;
          card.querySelector('[data-hint]').classList.remove('is-visible');
          card.querySelector('[data-price-slot]').innerHTML = priceHTML(+b.dataset.price, +b.dataset.compare);
        });

        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-add]');
          if (btn) {
            var card = btn.closest('.kb-card');
            var vid = card.dataset.variant || card.dataset.single;
            if (!vid) {
              card.querySelector('[data-hint]').classList.add('is-visible');
              shake(card.querySelector('.kb-sizes'));
              return;
            }
            btn.classList.add('is-loading');
            addItems([{ id: Number(vid), quantity: 1 }]).catch(function (err) {
              btn.classList.remove('is-loading');
              var h = card.querySelector('[data-hint]');
              h.textContent = err.message; h.classList.add('is-visible');
            });
          }
          var arrow = e.target.closest('[data-dir]');
          if (arrow) {
            track.scrollBy({ left: Number(arrow.dataset.dir) * (track.clientWidth * 0.8), behavior: 'smooth' });
          }
        });
      }
    });
  }

  /* =========================================================
     Product page: Wear it with (currently switched off in kast-pair-with.liquid)
     ========================================================= */
  function mainForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function currentVariantId() {
    var f = mainForm();
    var input = f && f.querySelector('[name="id"]');
    return input ? Number(input.value) : null;
  }

  if (!customElements.get('kast-pair-with')) {
    customElements.define('kast-pair-with', class extends HTMLElement {
      connectedCallback() {
        /* move right under the add to bag / stock notice */
        if (!this._placed) {
          this._placed = true;
          var form = mainForm();
          var anchor = document.querySelector('.product__inventory-notice') || (form && form.closest('.product__block'));
          if (anchor && anchor.parentNode && !anchor.contains(this)) { anchor.insertAdjacentElement('afterend', this); return; }
        }
        if (this._init) return;
        this._init = true;
        var self = this;
        this.list = this.querySelector('[data-list]');
        this.totalEl = this.querySelector('[data-total]');
        this.btn = this.querySelector('[data-add]');
        this.msg = this.querySelector('[data-msg]');
        var pid = Number(this.dataset.productId);

        Promise.all([getProduct(this.dataset.handle), related(pid, 10)]).then(function (res) {
          var base = res[0];
          self.base = base;
          var picks = pickMix(res[1], [base.type], [pid], 2);
          if (!picks.length) return;
          self.items = picks;
          self.render();
          self.hidden = false;
        }).catch(function () {});

        bindPills(this, function (b) {
          var row = b.closest('.kb-pair__row');
          row.dataset.variant = b.dataset.variant;
          row.dataset.price = b.dataset.price;
          self.msg.textContent = '';
          self.update();
        });
        this.addEventListener('change', function (e) {
          if (e.target.matches('.kb-check')) {
            e.target.closest('.kb-pair__row').classList.toggle('is-off', !e.target.checked);
            self.update();
          }
        });
        this.btn.addEventListener('click', function () { self.submit(); });

        /* follow the main size picker */
        var sync = function () { setTimeout(function () { self.syncBase(); }, 60); };
        document.addEventListener('change', sync);
        document.addEventListener('click', function (e) { if (!self.contains(e.target)) sync(); });
      }

      baseVariant() {
        if (!this.base) return null;
        var id = currentVariantId();
        return this.base.variants.find(function (v) { return v.id === id; }) || this.base.variants[0];
      }

      render() {
        var b = this.base;
        var bv = this.baseVariant();
        var rows = '<li class="kb-pair__row" data-base>' +
          '<input type="checkbox" class="kb-check" checked disabled aria-label="This item">' +
          '<div class="kb-pair__media"><img alt="' + esc(b.title) + '" src="' + img(b.featured_image, 160) + '"></div>' +
          '<div class="kb-pair__info"><span class="kb-pair__tag">This item</span>' +
          '<span class="kb-pair__title">' + esc(b.title) + '</span>' +
          '<div class="kb-pair__meta"><span data-base-price>' + priceHTML(bv.price, bv.compare_at_price) + '</span>' +
          (b.variants.length > 1 ? '<span class="kb-pair__pick" data-base-size>Size: ' + esc(bv.title) + '</span>' : '') +
          '</div></div></li>';

        rows += this.items.map(function (p) {
          var single = p.variants.length <= 1 ? p.variants[0] : null;
          return '<li class="kb-pair__row" data-product="' + p.id + '" data-title="' + esc(p.title) + '"' +
            (single ? ' data-variant="' + single.id + '" data-price="' + single.price + '"' : ' data-price="' + p.price + '"') + '>' +
            '<input type="checkbox" class="kb-check" checked aria-label="Include ' + esc(p.title) + '">' +
            '<a class="kb-pair__media" href="' + p.url + '"><img loading="lazy" alt="' + esc(p.title) + '" src="' + img(p.featured_image, 160) + '"></a>' +
            '<div class="kb-pair__info"><a class="kb-pair__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
            '<div class="kb-pair__meta">' + priceHTML(p.price, p.compare_at_price) + '</div>' +
            sizePickerHTML(p) + '</div></li>';
        }).join('');
        this.list.innerHTML = rows;
        this.update();
      }

      syncBase() {
        if (!this.base) return;
        var bv = this.baseVariant();
        var p = this.querySelector('[data-base-price]');
        var s = this.querySelector('[data-base-size]');
        if (p) p.innerHTML = priceHTML(bv.price, bv.compare_at_price);
        if (s) s.textContent = 'Size: ' + bv.title;
        this.update();
      }

      update() {
        var bv = this.baseVariant();
        if (!bv) return;
        var total = bv.price;
        var count = 1;
        this.querySelectorAll('.kb-pair__row[data-product]').forEach(function (row) {
          if (row.querySelector('.kb-check').checked) { total += Number(row.dataset.price || 0); count++; }
        });
        this.totalEl.textContent = money(total);
        this.btn.disabled = count < 2;
        this.btn.querySelector('.kb-btn__label').textContent = count < 2 ? 'Pick an item' : 'Add ' + count + ' to bag';
        var perk = this.querySelector('[data-perk]');
        if (perk) perk.hidden = count < FREE_ITEMS;
      }

      submit() {
        var self = this;
        var bv = this.baseVariant();
        if (!bv.available) { this.msg.textContent = 'This size is sold out. Pick another size above.'; return; }
        var items = [{ id: bv.id, quantity: 1 }];
        var missing = null;
        this.querySelectorAll('.kb-pair__row[data-product]').forEach(function (row) {
          if (!row.querySelector('.kb-check').checked) return;
          if (!row.dataset.variant) { if (!missing) missing = row; return; }
          items.push({ id: Number(row.dataset.variant), quantity: 1 });
        });
        if (missing) {
          this.msg.textContent = 'Pick a size for ' + missing.dataset.title;
          shake(missing.querySelector('.kb-sizes'));
          return;
        }
        this.msg.textContent = '';
        this.btn.classList.add('is-loading');
        addItems(items).then(function () {
          self.btn.classList.remove('is-loading');
          self.btn.classList.add('is-done');
          self.btn.querySelector('.kb-btn__label').textContent = 'Added';
          setTimeout(function () { self.btn.classList.remove('is-done'); self.update(); }, 2200);
        }).catch(function (err) {
          self.btn.classList.remove('is-loading');
          self.msg.textContent = err.message;
        });
      }
    });
  }

  /* =========================================================
     Sticky add to bag
     ========================================================= */
  if (!customElements.get('kast-sticky-atc')) {
    customElements.define('kast-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this.parentNode !== document.body) { document.body.appendChild(this); return; }
        if (this._init) return;
        this._init = true;
        var self = this;
        var form = mainForm();
        this.real = form && form.querySelector('[type="submit"], .product-form__submit');
        if (!this.real) return;
        this.btn = this.querySelector('[data-sticky-add]');
        this.meta = this.querySelector('[data-meta]');
        getProduct(this.dataset.handle).then(function (p) { self.product = p; self.refresh(); });

        /* show once the real add to bag button has scrolled off the top */
        var ticking = false;
        var check = function () {
          ticking = false;
          var f = mainForm();
          var real = f && f.querySelector('[type="submit"], .product-form__submit');
          if (real) self.real = real;
          var show = self.real.getBoundingClientRect().bottom < 0;
          self.classList.toggle('is-visible', show);
          document.body.classList.toggle('kb-sticky-on', show);
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(check); }
        }, { passive: true });
        check();

        this.btn.addEventListener('click', function () {
          if (self.real.disabled) {
            self.real.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          self.btn.classList.add('is-loading');
          self.real.click();
          setTimeout(function () { self.btn.classList.remove('is-loading'); }, 1400);
        });
        var r = function () { setTimeout(function () { self.refresh(); }, 80); };
        document.addEventListener('change', r);
        document.addEventListener('click', function (e) { if (!self.contains(e.target)) r(); });
      }
      refresh() {
        if (!this.product) return;
        var id = currentVariantId();
        var v = this.product.variants.find(function (x) { return x.id === id; }) || this.product.variants[0];
        var size = this.product.variants.length > 1 ? ' &middot; ' + esc(v.title) : '';
        this.meta.innerHTML = '<strong>' + money(v.price) + '</strong>' + size;
        var label = this.btn.querySelector('.kb-btn__label');
        label.textContent = v.available ? 'Add to bag' : 'Sold out';
        this.btn.toggleAttribute('disabled', !v.available);
      }
    });
  }
})();